export default "__VITE_ASSET__CXnBjC0Q__"